/** The Auth0 Management API scopes the connector's application needs, in the
 * order the installer lists them. They're the connector's
 * `AUTH0_REQUIRED_SCOPES` (p0-connector-auth0), which its install check
 * requires. The backend's tests keep the two the same. */
export const AUTH0_MANAGEMENT_SCOPES = [
  "read:users",
  "read:roles",
  "read:role_members",
  "update:users",
  "create:role_members",
  "delete:role_members",
  "read:resource_servers",
  "read:user_effective_permissions",
  "read:organizations",
  "read:organization_members",
  "read:organization_member_roles",
  "create:organization_members",
  "delete:organization_members",
  "create:organization_member_roles",
  "delete:organization_member_roles",
] as const;
